import { Injectable } from '@angular/core';
import { LANGUAGE } from '../shared/utils';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class TableFunctionService {

  constructor() { }


  destruirTabla(idTable: string) {
    this.destroyTable(idTable);
  }

  construirTabla(idTable: string) {
    // this.chRef.detectChanges();
    this.createTable(idTable, false, true, '400px', true);
  }

  destroyTable(table: string) {
    $(`#${table}`).DataTable().clear().destroy();
  }

  createTable(table: string, searching: boolean, ordering: boolean, scrollY: string, info?: boolean) {
    $(`#${table}`).DataTable({
      initComplete: function () {
        $(this.api().table().container()).find('input').parent().wrap('<form>').parent().attr('autocomplete', 'off');
      },
      paging: false,
      lengthChange: true,
      searching: searching,
      ordering: ordering,
      info: info,
      autoWidth: true,
      scrollX: true,
      scrollY: scrollY,
      language: LANGUAGE,
    });

    $(`#${table} tr`).click(function (e) {
      if ($(this).hasClass("selected")) {
        $(`#${table} tr`).removeClass("selected");
        $(this).removeClass("selected");
      } else {
        $(`#${table} tr`).removeClass("selected");
        $(this).addClass("selected");
      }
    });
  }
}